import styled from 'styled-components';
import styleUtils from '../../../../styles/style.utils';
import themedColor from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';

const Container = styled.div`
  margin-bottom: ${styleUtils.px(18)};
  flex-basis: 100%;
`;

const StyledTextarea = styled.textarea`
  resize: none;
  background: ${themedColor('INPUT_BG')};
  border: 1px solid ${themedColor('INPUT_BORDER')};
  border-radius: 21px;
  padding: ${styleUtils.px(16)};
  min-width: ${styleUtils.size('MIN_INPUT_WIDTH')};
  width: 100%;
  color: ${themedColor('TEXT_BLUE')};
  font-size: ${themedFontSize('FORM')};
  font-weight: 400;

  &:not(:empty) {
    border: 1px solid ${themedColor('INPUT_ENTERED_BORDER')};
    background: ${themedColor('INPUT_ENTERED_BG')};
  }

  &:focus {
    outline: 0;
    border-color: ${themedColor('INPUT_FOCUS_BORDER')};
  }

  &:hover {
    outline: 0;
    border-color: ${themedColor('INPUT_FOCUS_BORDER')};
  }
`;

const FormTextareaComponents = { Container, StyledTextarea };

export default FormTextareaComponents;
